/*
**当找不到路由时展示--404
*/
import React, { Component } from 'react';
import img404 from '../../../static/images/pic_404.png';

export default class NoMatch extends Component{
    render(){
        return(
            <img src={img404} alt="404 Not Found" style={{width:'100%',overflow:'hidden'}}/>
        )
    }
}


// WEBPACK FOOTER //
// ./src/page/App/common/404.js